import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { CustomersService } from 'src/app/services/customer.service';
import { CustomerInsightService } from '../service/customer-insight.service';

@Component({
  selector: 'kt-referral-metrics',
  templateUrl: './referral-metrics.component.html',
  styleUrls: ['./referral-metrics.component.css']
})
export class ReferralMetricsComponent implements OnInit {

  @Input() customerId: number;
  @Input() isFinancialYear: boolean=false;
  @Output() dataLoaded = new EventEmitter<void>(); // Event emitter for data load

  referralBusinessData: any={ labels: [], data: [], total: '', reportLabel: '', options: {} };
  loading:boolean=true;
  lastUpdatedSince:any=''
  private loadingSubject = new BehaviorSubject<boolean>(true);
  loading$ = this.loadingSubject.asObservable().pipe(shareReplay(1));;



  constructor(
    private customerService: CustomersService,
    private customerInsightService: CustomerInsightService,
  ) { }

  ngOnInit(): void {
    if (this.customerId && this.customerId > 0) {
      setTimeout(()=>{
        this.fetchReferralBusiness();
      },1000)
    }
  }

  fetchReferralBusiness():void{
    this.loadingSubject.next(true);
    this.customerService.getReferralBusiness(this.customerId,this.isFinancialYear).subscribe({
      next:(res:any)=>{
        // this.referralBusinessData = res.data;
        this.lastUpdatedSince = (res && res.data && res.data.lastUpdatedSince) ? res.data.lastUpdatedSince : '';
        this.loadingSubject.next(false);
        if(res.data){
          this.transformReferralBusiness(res.data);
          this.dataLoaded.emit();
        }else{
          this.dataLoaded.emit();
        }
      },
      error:()=>{
        this.loadingSubject.next(false);
        this.dataLoaded.emit();
      }
    })
  }

  transformReferralBusiness(data:any){
    this.referralBusinessData.labels = ['Total Business','Total Amount','Reward'];
    this.referralBusinessData.data=[
      {
        data: [data.TotalBusiness,data.TotalTransactionValue,data.TotalReferralReward],
        color: this.customerInsightService.generateBlueShades(this.referralBusinessData.labels.length)
      }
    ]
  }
}
